import React, {Component} from "react";
import Select from "react-select"
import Jquery from "jquery";

class GenderSelect extends Component {

    styles = {
        option: (provided, state) => ({
            ...provided,
            background: state.isFocused ? "#182237" : "none",
            color: state.isFocused ? "#fff" : "#6c757d",
            fontSize: "14px"
        })
    };

    render() {
        return (
            <>
                <Select
                    styles={this.styles}
                    placeholder={""}
                    className={"select"}
                    classNamePrefix={"select"}
                    value={this.props.value}
                    options={this.props.options}
                    onChange={this.props.onChange}
                    onFocus={() => {
                        Jquery("#gender-label").addClass("focused-label");
                    }}
                    onBlur={() => {
                        if (!this.props.value) {
                            Jquery("#gender-label").removeClass("focused-label");
                        }
                    }}
                    required={true}
                    searchable={false}
                    ref={(ref) => {
                        this.select = ref;
                    }}
                />
                <input
                    tabIndex={-1}
                    value={this.props.value}
                    required={true}
                    style={{
                        opacity: 0,
                        width: 0,
                        height: 0,
                        position: "absolute",
                    }}
                    onChange={() => {
                    }}
                    onFocus={() => this.select.focus()}
                />

                <label className={"form-label"} id={"gender-label"}>Anrede</label>
            </>
        );
    }
}

export default GenderSelect;


